<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">CIP 顧客情報</div>
      <div class="panel-body">
        <h4>検索項目</h4>
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="form-inline">
              <label class="control-label" for="account">お客様番号</label>
              <input v-model="account" id="account" type="text" class="form-control">
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="form-inline">
              <label class="control-label" for="name-kana">氏名（カナ）</label>
              <input v-model="familyNameKana" id="name-kana" type="text" class="form-control">
              <input v-model="firstNameKana" type="text" class="form-control">
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-md-6 col-sm-6">
            <div class="form-inline">
              <label class="control-label" for="phone-number">電話番号　</label>
              <input v-model="phoneNumber" id="phone-number" type="text" class="form-control">
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="form-inline">
              <label class="control-label" for="name-kana">氏名　　　　</label>
              <input v-model="familyName" id="name-kana" type="text" class="form-control">
              <input v-model="firstName" type="text" class="form-control">
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-md-8 col-sm-8">
            <div class="form-inline">
              <label class="control-label" for="shop">登録店舗</label>
              <select id="shop" multiple class="form-control" v-model="selectedShops">
                <option v-for="shop in shops" value="{{ shop.pk }}">{{ shop.name }}({{ shop.code }})</option>
              </select>
            </div>
            <small class="text-muted">複数選択するときには Control キーを押したまま選択してください。Mac では Command キーを使ってください</small>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-sm-12">
            <button class="btn btn-primary" @click="search">検索</button>
          </div>
        </div>
      </div>
      <div cpass="panel-body" v-show="searched">
        <hr>
        <h4>検索結果</h4>
        <div class="row" v-if="showResults">
          <div class="col-sm-12">
            <div v-if="tooMany">
              <h4 style="color: red;">検索結果が{{ maxPageSize }}件を超えています。検索内容を増やしてください。</h4> ({{ hitCount }}件一致)
            </div>
            <table class="table table-striped table-bordered search-result">
              <thead>
                <tr>
                  <th>登録店舗</th>
                  <th>お客様番号</th>
                  <th>氏名</th>
                  <th>氏名(カナ)</th>
                  <th>電話番号</th>
                  <th>登録日時</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in customers">
                  <td>{{ obj.shopName }} ({{ obj.shopCode }})</td>
                  <td>{{ obj.account }}</td>
                  <td>{{ obj.familyName }} {{ obj.firstName }}</td>
                  <td>{{ obj.familyNameKana }} {{ obj.firstNameKana }}</td>
                  <td>{{ obj.phoneNumber }}</td>
                  <td>{{ obj.createdAt|formattedDateTime }}</td>
                  <td><button class="btn btn-primary" @click="detail(obj)">詳細</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" v-else>
          条件に一致する顧客情報はありません。
        </div>
      </div>
    </div>
    <customer-detail-modal @updated="refresh" v-ref:customer-detail-modal></customer-detail-modal>
  </div>
</template>

<script lang="babel">
import moment from 'moment'

export default {
  data () {
    return {
      account: null,
      phoneNumber: null,
      firstName: null,
      familyName: null,
      firstNameKana: null,
      familyNameKana: null,
      customers: [],
      hitCount: 0,
      searched: false,
      tooMany: false,
      shops: [],
      selectedShops: [],
      maxPageSize: 10,
    }
  },
  computed: {
    showResults () {
      return !!this.hitCount
    },
  },
  methods: {
    search () {
      let query = {
        page_size: this.maxPageSize,
        account: this.account,
        phone_number: this.phoneNumber,
        first_name: this.firstName,
        family_name: this.familyName,
        first_name_kana: this.firstNameKana,
        family_name_kana: this.familyNameKana,
        shops: this.selectedShops,
      }
      /*
      Object.keys(query).forEach(key => {
        if (query[key] === '') {
          query[key] = null
        }
      })
      */
      this.apiGet(`/api/1.0/customers/`, query).then(res => {
        this.customers = res.body.results
        this.hitCount = res.body.count
        this.tooMany = !!(res.body.next)
        this.searched = true
      })
    },
    refresh () {
      this.search()
    },
    detail (obj) {
      this.$refs.customerDetailModal.show(obj)
    },
    fetchData () {
      this.apiGet(`/api/1.0/shops/`, {page_size: -1}).then(res => {
        this.shops = res.body.results.filter(v => v.shopType === 1)
      })
    },
  },
  ready () { // mounted for v2
    this.fetchData()
  },
  filters: {
    formattedDateTime (val) {
      return moment(val).locale('ja').format('YYYY/MM/DD (ddd) HH:mm')
    },
  },
  components: {
    customerDetailModal: require('customer/modal-form/detail.vue'),
  },
  mixins: [
    require('mixin/login-required.vue'),
    require('mixin/api-client.vue'),
  ],
}
</script>

<style scoped>
.search-result {
  width: 90%;
  margin-left: 5%;
}

.control-label {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// index.vue?422d6dca